import React from "react";
import "./Stepper.css";
import { ChevronLeftIcon, ChevronRightIcon, MinusIcon, PlusIcon } from "../Icons/Icons";

interface StepperProps {
    label: string;
    value: React.ReactNode;
    unit?: string;
    onDecrement: () => void;
    onIncrement: () => void;
    decrementDisabled?: boolean;
    incrementDisabled?: boolean;
    /** Left/right chevrons instead of −/+, for settings that pick a mode rather than a number. */
    mode?: boolean;
    /** Omit the title when the caller shows it elsewhere (label is still used for a11y). */
    hideLabel?: boolean;
}

const isWord = (value: React.ReactNode) =>
    typeof value === 'string' && value.length > 2 && !/^[+-]?[\d.]+$/.test(value);

// A single stepped spa setting: title, then [−] value [+], unit underneath.
// Buttons dim rather than disappear at the limits so the layout never shifts.
const Stepper = ({ label, value, unit, onDecrement, onIncrement, decrementDisabled, incrementDisabled, mode, hideLabel }: StepperProps) => (
    <section className="stepper">
        {!hideLabel && <span className="stepper-label">{label}</span>}
        <div className="stepper-row">
            <button className="stepper-button" onClick={onDecrement} disabled={decrementDisabled} aria-label={`Decrease ${label}`}>
                {mode ? <ChevronLeftIcon /> : <MinusIcon />}
            </button>
            {/* Words (e.g. "P1 HIGH") step down a size so they fit; numbers like "+150" don't */}
            <span className={`stepper-value ${isWord(value) ? 'word' : ''}`}>{value}</span>
            <button className="stepper-button" onClick={onIncrement} disabled={incrementDisabled} aria-label={`Increase ${label}`}>
                {mode ? <ChevronRightIcon /> : <PlusIcon />}
            </button>
        </div>
        {/* Always rendered (blank when unitless) so side-by-side steppers line up */}
        <span className="stepper-unit">{unit || '\u00a0'}</span>
    </section>
);

export default Stepper;
